// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Bundles_blockWrapper__tgBR3","scrollWrapper":"Bundles_scrollWrapper__RuIGz","content":"Bundles_content__kLmLS"};